const state = {
    poslogApi: null,
    anonymized: true,
    currentView: "",
    downloadMeta: {
        ext: "",
        contentType: ""
    },
    transactionId: null,
    messageDateTime: null,
    version: null,
    xml: "",
    lang: "plaintext",
    history: []
};

export default state;
